import { render, staticRenderFns } from "./BranchButton.vue?vue&type=template&id=55846150"
import script from "./BranchButton.vue?vue&type=script&lang=js"
export * from "./BranchButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports